import axios from "axios";
import { track, trackAdsConversion } from "./analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getCategories = () => axios.get(`${API}/categories`).then((r) => r.data);
export const getServices = (params = {}) =>
  axios.get(`${API}/services`, { params }).then((r) => r.data);
export const getService = (slug) => axios.get(`${API}/services/${slug}`).then((r) => r.data);
export const getFaqs = () => axios.get(`${API}/faqs`).then((r) => r.data);
export const postLead = (payload) =>
  axios.post(`${API}/leads`, payload).then((r) => {
    track("lead_submit", { service: payload.serviceId || "generico", source: payload.source || "form" });
    trackAdsConversion("lead_submit");
    return r.data;
  });
export const postAppointment = (payload) => axios.post(`${API}/appointments`, payload).then((r) => r.data);

export const getUtm = () => {
  const p = new URLSearchParams(window.location.search);
  const out = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => {
    if (p.get(k)) out[k] = p.get(k);
  });
  return out;
};
